import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { create } from "zustand";
import { devtools } from "zustand/middleware";
/** Returns the list with any currently-open composer set to minimised. */
function minimiseOpen(composers) {
  return composers.map(function (composer) {
    return composer.status === "open" ? _objectSpread(_objectSpread({}, composer), {}, {
      status: "minimized"
    }) : composer;
  });
}

/** Global store for open/minimised composer sessions (reports, letters, notes). */
export var useComposerStore = create()(devtools(function (set) {
  return {
    composers: [],
    isTagsEditMode: false,
    setTagsEditMode: function setTagsEditMode(active) {
      return set({
        isTagsEditMode: active
      }, false, "setTagsEditMode");
    },
    open: function open(input) {
      return set(function (state) {
        var others = minimiseOpen(state.composers);
        if (others.some(function (composer) {
          return composer.id === input.id;
        })) {
          return {
            composers: others.map(function (composer) {
              return composer.id === input.id ? _objectSpread(_objectSpread(_objectSpread({}, composer), input), {}, {
                status: "open"
              }) : composer;
            })
          };
        }
        return {
          composers: [].concat(_toConsumableArray(others), [_objectSpread(_objectSpread({
            content: ""
          }, input), {}, {
            status: "open"
          })])
        };
      }, false, "open");
    },
    minimize: function minimize(id) {
      return set(function (state) {
        return {
          composers: state.composers.map(function (composer) {
            return composer.id === id ? _objectSpread(_objectSpread({}, composer), {}, {
              status: "minimized"
            }) : composer;
          })
        };
      }, false, "minimize");
    },
    restore: function restore(id) {
      return set(function (state) {
        return {
          composers: minimiseOpen(state.composers).map(function (composer) {
            return composer.id === id ? _objectSpread(_objectSpread({}, composer), {}, {
              status: "open"
            }) : composer;
          })
        };
      }, false, "restore");
    },
    close: function close(id) {
      return set(function (state) {
        return {
          composers: state.composers.filter(function (composer) {
            return composer.id !== id;
          })
        };
      }, false, "close");
    },
    closeAll: function closeAll() {
      return set({
        composers: []
      }, false, "closeAll");
    },
    setContent: function setContent(id, content) {
      return set(function (state) {
        return {
          composers: state.composers.map(function (composer) {
            return composer.id === id ? _objectSpread(_objectSpread({}, composer), {}, {
              content: content
            }) : composer;
          })
        };
      }, false, "setContent");
    }
  };
}, {
  name: "ComposerStore",
  enabled: typeof window !== "undefined" && process.env.NODE_ENV !== "production"
}));